import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { useLayoutEffect } from 'react';

var useAutoScrollConsoleToBottom = function useAutoScrollConsoleToBottom(_ref) {
  var scrollWhenAnyValueChanges = _ref.scrollWhenAnyValueChanges,
      divElementRef = _ref.divElementRef;
  useLayoutEffect(function () {
    var divElement = divElementRef.current;

    if (divElement == null) {
      return;
    }

    divElement.scrollTop = divElement.scrollHeight; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [].concat(_toConsumableArray(scrollWhenAnyValueChanges), [divElementRef]));
};

export default useAutoScrollConsoleToBottom;